<template>
  <div class="content">
    <div v-for="(item, index) in tests" :key="index">
      <Card :item="item.evaluation" @click="gotoDetail(item.id)"></Card>
    </div>
  </div>
</template>
<script>
import Card from "./Card";
export default {
  name: "TestList",
  props: {
    tests: Array,
    flag: Number,
  },
  data() {
    return {};
  },
  watch: {
    tests(val) {
      this.tests = val;
      console.log("结果", this.tests);
    },
    flag(val) {
      this.flag = val;
    },
  },
  method: {
    // 查看测评
    gotoDetail(id) {},
  },
  components: {
    Card,
  },
};
</script>
<style lang="less" scoped>
.more {
  float: right;
}
</style>
